module.exports = __webpack_public_path__ + "static/media/questionMarkCircle.011e4f9f.svg";